<template>
	<div>
		<div v-if="selected">
			<b>{{ "stock" | trans }}:</b> <span>{{ selected.stock }}</span>
		</div>
		<v-autocomplete
			v-if="stocks.length"
			required
			v-model="selected"
			:rules="rules"
			open-on-clear
			:label="label | trans"
			@input="$emit('input', $event)"
			:items="stocks"
			solo
			filled
			hide-details
			return-object
		>
			<template v-slot:item="data">
				<v-list-item v-on="data.on" :disabled="data.item.stock <= 0" v-bind="data.attrs">
					<v-list-item-content>
						<v-list-item-title>
							{{ data.item.text }}
						</v-list-item-title>
						<v-list-item-subtitle>
							<b>{{ "stock" | trans }}: </b> {{ data.item.stock }}
						</v-list-item-subtitle>
					</v-list-item-content>
				</v-list-item>
			</template>
		</v-autocomplete>
	</div>
</template>
<script>
export default {
	mounted() {},
	data() {
		return {
			rules: [(v) => !!v || "required"],
			selected: null,
		};
	},
	props: {
		product: { required: true },
		value: { required: true },
		label: { default: "option" },
	},
	watch: {
		value() {
			this.selected = this.value;
		},
	},
	computed: {
		stocks() {
			if (!this.product.advanced_stock) return [];
			return this.product.advanced_stock.map((stock, i) => {
				return {
					index: i,
					text: Object.keys(stock)
						.filter((key) => key != "stock")
						.map((k) => `${k}: ${stock[k]}`)
						.join(", "),
					stock: stock.stock,
				};
			});
		},
	},
};
</script>
